/**
 * Real-time collaboration config. The collab server URL is injected at build
 * time (VITE_COLLAB_URL, set from the deployed Cloud Run service); when absent,
 * collaboration is simply disabled and the share editor stays single-user.
 */
export const COLLAB_URL: string | undefined = import.meta.env.VITE_COLLAB_URL;

export function collabEnabled(): boolean {
  return typeof COLLAB_URL === 'string' && COLLAB_URL.length > 0;
}

const ADJECTIVES = ['Swift', 'Calm', 'Bright', 'Bold', 'Keen', 'Warm', 'Lucid', 'Merry'];
const BIRDS = ['Kingfisher', 'Heron', 'Robin', 'Finch', 'Swallow', 'Wren', 'Lark', 'Owl'];
const COLORS = [
  '#00808d',
  '#e07a5f',
  '#3d84a8',
  '#8e7dbe',
  '#c05780',
  '#4c956c',
  '#d1495b',
  '#8367c7',
];

export interface CollabUser {
  name: string;
  color: string;
}

/** A stable-per-session random display name + color for presence. */
export function makeCollabUser(seed: number): CollabUser {
  const a = ADJECTIVES[seed % ADJECTIVES.length]!;
  const b = BIRDS[(seed >> 3) % BIRDS.length]!;
  const color = COLORS[(seed >> 1) % COLORS.length]!;
  return { name: `${a} ${b}`, color };
}
